module.exports = "/_next/static/images/00d5b0d0f4b867545a4f99f9611940ee-google-screen.png.webp";